'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import I18n from 'I18n';
import { useSearchParam } from '../../hooks/searchParamHooks';
import { items } from './RouterDropdownFilter';
import LanguageNames from 'ui-addon-i18n/constants/LanguageNames';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIButton from 'UIComponents/button/UIButton';
import { BATTLESHIP } from 'HubStyleTokens/colors';
import { FormattedMessage } from 'LearningCenterUI/components/I18n';
import useLanguageRequested from '../../hooks/useLanguageRequests';
import UsageTracker from '../../utils/UsageTracker';
export const MobileFilterSingleSelect = ({
  defaultItem,
  trackId,
  lessonId,
  allowList,
  filterType,
  onSelect,
  buttonStyle
}) => {
  const options = items[filterType] || [];
  const [__, changeHandler] = useSearchParam(filterType);
  return options.map(option => {
    const disabled = !!allowList && !allowList.includes(option); // eslint-disable-next-line react-hooks/rules-of-hooks

    const [languageRequested, setLanguageRequested] = useLanguageRequested({
      trackId,
      lessonId,
      language: option
    });
    return /*#__PURE__*/_jsxs(UIFlex, {
      onClick: () => {
        if (!disabled) {
          onSelect();
          changeHandler(option);
          UsageTracker.track('filterInteraction', {
            action: 'filter-selected',
            value: option,
            key: 'language-switcher',
            defaultValue: defaultItem
          });
        }
      },
      children: [/*#__PURE__*/_jsx(UIButton, {
        disabled: disabled,
        style: Object.assign({
          color: disabled && BATTLESHIP
        }, buttonStyle),
        use: "unstyled",
        children: filterType === 'language' ? LanguageNames[option.toLowerCase()] : I18n.text(`learningCenter.topFilters.${filterType}.${option}`)
      }), disabled && /*#__PURE__*/_jsx(UIButton, {
        disabled: languageRequested,
        onClick: setLanguageRequested,
        style: Object.assign({
          overflow: 'visible',
          padding: '3px',
          width: 'auto'
        }, buttonStyle),
        use: "transparent",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `learningCenter.requestLanguage.${languageRequested ? 'requested' : 'request'}.button`
        })
      })]
    }, option);
  });
};
MobileFilterSingleSelect.propTypes = {
  filterType: PropTypes.string.isRequired
};
export default MobileFilterSingleSelect;